import { useState } from 'react';

import Modal from '../../atoms/modal/modal';
import BoletinSubscriptionForm from '../../molecules/boletin-subscription-form/boletinSubscriptionForm';
import BulletinModal from '../../molecules/bulletin-modal/bulletinModal';
import InfoSlider from '../../molecules/info-slider/infoSlider';
import SimpleBanner from '../../molecules/simple-banner/simpleBanner';

interface SimpleBannerInterface {
  contentfulData: any;
}

const ElectronicBulletin = (props: SimpleBannerInterface) => {
  const { contentfulData } = props;
  const [bulletinModal, setBulletinModal] = useState(false);
  const [selectedButtons, setSelectedButtons] = useState<any>(null);

  return (
    <div className="o-electronicBulletin">
      {bulletinModal && (
        <Modal open={bulletinModal} onClose={() => setBulletinModal(false)}>
          <BulletinModal
            modalInfo={contentfulData.modal[0]}
            selectedButtons={selectedButtons}
            setSelectedButtons={setSelectedButtons}
            setBulletinModal={setBulletinModal}
          />
        </Modal>
      )}
      <SimpleBanner
        copyBoton={contentfulData.referencias[0].boton[0].copy}
        imageSrc={contentfulData.referencias[0].imagen[0]}
        redireccion={contentfulData.referencias[0].boton[0].redireccion}
        titulo={contentfulData.referencias[0].titulo}
        subtitulo={contentfulData.referencias[0].subtitulo}
      />
      <InfoSlider referenciaPlantillaContenido={contentfulData.secciones[0]} />
      <BoletinSubscriptionForm
        inputReferences={contentfulData.estoTambien}
        setBulletinModal={setBulletinModal}
      />
    </div>
  );
};

export default ElectronicBulletin;
